import React from "react";
import { Link } from "react-router-dom";

const PageFooter = ({ compact = false }) => {
  const year = new Date().getFullYear();
  const appTitle = process.env.REACT_APP_TITLE || "Thadotech Gateway Manager";

  const quickLinks = [
    { to: "/", label: "Overview" },
    { to: "/orders", label: "Orders" },
    { to: "/stores", label: "Stores" },
    { to: "/settings", label: "Settings" },
  ];

  const legalLinks = [
    { to: "/policy", label: "Policy" },
    { to: "/profile", label: "Account" },
  ];

  return (
    <footer className={`main-footer ${compact ? "compact-footer" : ""}`.trim()}>
      {!compact && (
        <div className="footer-main-content container">
          <div className="footer-branding">
            <p className="footer-eyebrow">Operations Platform</p>
            <h6 className="footer-title mb-2">{appTitle}</h6>
            <p className="footer-description mb-0">
              Manage orders, synchronize data, and track multi-channel performance
              from one centralized dashboard.
            </p>
          </div>

          <div className="footer-links-wrap">
            <div>
              <h6 className="footer-section-title">Quick Links</h6>
              <ul className="footer-links-list">
                {quickLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h6 className="footer-section-title">Support</h6>
              <ul className="footer-links-list">
                <li>
                  <Link to="/mail-templates">Email Templates</Link>
                </li>
                <li>
                  <Link to="/workspace">Workspaces</Link>
                </li>
                <li>
                  <a href="mailto:support@onealdern.com">support@onealdern.com</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-status-card" aria-label="System status">
            <span className="status-dot" aria-hidden="true" />
            <div>
              <p className="status-title mb-1">System operating normally</p>
              <small className="status-text">API connections and background jobs are online</small>
            </div>
          </div>
        </div>
      )}

      <div className="footer-bottom container">
        <p className="copy-right mb-0">
          &copy; {year} <strong>{appTitle}</strong>. All rights reserved.
        </p>
        <div className="footer-legal-links">
          {legalLinks.map((link) => (
            <Link key={link.to} to={link.to}>
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
